import { render, staticRenderFns } from "./GuardEdit.vue?vue&type=template&id=53d625db&"
import script from "./GuardEdit.vue?vue&type=script&lang=js&"
export * from "./GuardEdit.vue?vue&type=script&lang=js&"
import style0 from "./GuardEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports